<template>
    <div class="promo">
        <input type="text" v-model="promocode" placeholder="Промокод">
        <button @click="clickPromocodeButton" :disabled="lockButton">Применить</button>
        <div v-if="error.exist" class="error">{{ error.message }}</div>
    </div>
</template>
<script>
    import './promocode.scss'

    export default {
       name: 'Promocode',
       props: ['user'],
       data() {
         return {
            promocode: '',
            error: {
                exist: false,
                message: ''
            },
            loading: false
         }
       },
        methods: {
            setError: function (message) {
                this.error.exist = true;
                this.error.message = message;
            },
            clearError: function() {
                this.error.exist = false;
                this.error.message = '';
            },
            attachPromocode: function() {
                const self = this;

                return new Promise(function (resolve, reject) {
                    self.loading = true;

                    const formData = new FormData();
                    formData.append('cw', self.promocode);

                    let url = process.env.VUE_APP_HOST + '/mobile/user/policy/attach-promo/';
                    fetch(url, {
                        headers: new Headers({
                            'Authorization': 'Token ' + self.user.session,
                        }),
                        method: 'POST',
                        body: formData
                    }).then((response) => {
                        response.json().then(function (data) {
                            if (data.status === 'OK') {
                                resolve();
                            } else {
                                self.setError(data.message);
                                reject(data.message)
                            }

                            self.loading = false;
                        })
                    }, () => {
                        const message = 'Возникла неизвестная ошибка';
                        self.setError(message);
                        self.loading = false;

                        reject(message);
                    })
                });
            },
            clickPromocodeButton: function() {
                const self = this;

                this.attachPromocode().then(function () {
                    self.$emit('accepted');
                });
            }
        },
        computed: {
            lockButton: function () {
                return !this.promocode || this.loading;
            }
        },
        watch: {
            promocode: function() {
                this.clearError();
            }
        }
    }
</script>